import React, { Component } from "react";
import { render } from "react-dom";
import { ConfirmDialog, getTitle, getIcon } from "../ConfirmDialog";
import { ButtonGroupEnum, ButtonMessageEnum, MessageTypeEnum, LogLevel } from "../../../enums";
import { logController } from "../../../controllers/log.controller";

let resolve;
const defaultProps = {
    type: MessageTypeEnum.INFORMATIVE,
    message: "Are you sure?",
    buttons: ButtonGroupEnum.OK
};
class Confirm extends Component {
    static create(props = {}) {
        const containerElement = document.createElement("div");
        document.body.appendChild(containerElement);
        return render(<Confirm createConfirmProps={props} />, containerElement);
    }

    constructor() {
        super();

        this.state = {
            isOpen: false,
            showConfirmProps: {}
        };
    }

    CancelButton = () => {
        return {
            message: ButtonMessageEnum.CANCEL,
            callback: this.handleCancel
        };
    };

    OkButton = () => {
        return {
            message: ButtonMessageEnum.OK,
            callback: this.handleConfirm
        };
    };

    YesButton = () => {
        return {
            message: ButtonMessageEnum.YES,
            callback: this.handleYes
        };
    };

    NoButton = () => {
        return {
            message: ButtonMessageEnum.NO,
            callback: this.handleNo
        };
    };

    handleCancel = () => {
        this.handleButtonClick(ButtonMessageEnum.CANCEL);
    };

    handleConfirm = () => {
        this.handleButtonClick(ButtonMessageEnum.OK);
    };

    handleNo = () => {
        this.handleButtonClick(ButtonMessageEnum.NO);
    };

    handleYes = () => {
        this.handleButtonClick(ButtonMessageEnum.YES);
    };

    handleButtonClick(buttonResult) {
        this.setState({ isOpen: false });
        resolve(buttonResult);
        if (this.state.showConfirmProps.logMessage == true) {
            var logLevel = LogLevel.Information;
            switch (this.state.type) {
                case MessageTypeEnum.CRITICAL:
                    logLevel = LogLevel.Error;
                    break;
                case MessageTypeEnum.EXCLAMATION:
                    logLevel = LogLevel.Warning;
                    break;
                default:
                    logLevel = LogLevel.Information;
                    break;
            }
            logController.logMessage(`${this.state.showConfirmProps.message} => ${buttonResult}`, logLevel);
        }
    }

    async show(props = {}) {
        const showConfirmProps = { ...this.props.createConfirmProps, ...props };
        this.setState({ isOpen: true, showConfirmProps });

        if (!showConfirmProps.message || showConfirmProps.message == defaultProps.message) {
            console.error(new Error("Message is required for confirm dialog."));
        }

        var autoFocus = document.getElementById("ConfirmDialog");
        if (autoFocus) {
            autoFocus = autoFocus.getElementsByClassName("k-primary")[0];
            if (autoFocus) {
                autoFocus.focus();
            }
        }

        return new Promise((res) => {
            resolve = res;
        });
    }

    getButtonsByEnum(buttons, defaultButtons) {
        var buttons = buttons || defaultButtons;
        switch (buttons) {
            case ButtonGroupEnum.OK_CANCEL:
                return [this.OkButton(), this.CancelButton()];
            case ButtonGroupEnum.OK:
                return [this.OkButton()];
            case ButtonGroupEnum.YES_NO:
                return [this.YesButton(), this.NoButton()];
            case ButtonGroupEnum.YES_NO_CANCEL:
                return [this.YesButton(), this.NoButton(), this.CancelButton()];
        }
    }

    render() {
        const { isOpen, showConfirmProps } = this.state;
        const { message, title, buttons, type, icon, width, ...rest } = showConfirmProps;

        return (
            isOpen && (
                <ConfirmDialog
                    title={title || getTitle(type)}
                    icon={icon || getIcon(type)}
                    width={width || "400px"}
                    onCloseHandler={this.handleCancel}
                    message={message || defaultProps.message}
                    buttons={this.getButtonsByEnum(buttons, defaultProps.buttons)}
                />
            )
        );
    }
}

export default Confirm;



// WEBPACK FOOTER //
// ./src/components/common/confirmService/Confirm.js